"use client";

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@store/store";
import { openConsentModal } from "@store/features/cookieConsentSlice";
import { CookieConsentModal } from "./CookieConsentModal";

export function CookieManager() {
  const dispatch = useDispatch();
  const { hasUserDecided } = useSelector((state: RootState) => state.cookieConsent);

  useEffect(() => {
    // Show consent modal on first visit if user hasn't decided yet
    if (!hasUserDecided) {
      // Small delay to ensure the page is loaded
      const timer = setTimeout(() => {
        dispatch(openConsentModal());
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [hasUserDecided, dispatch]);

  return <CookieConsentModal />;
}

/**
 * Utility functions for cookie management
 */
export const cookieUtils = {
  /**
   * Check if cookies are accepted by the user
   */
  areCookiesAccepted: (state: RootState): boolean => {
    return state.cookieConsent.cookiesAccepted;
  },

  /**
   * Check if user has made a decision about cookies
   */
  hasUserDecidedOnCookies: (state: RootState): boolean => {
    return state.cookieConsent.hasUserDecided;
  },

  /**
   * Set a cookie only if cookies are accepted
   */
  setConditionalCookie: (name: string, value: string, options: any = {}, cookiesAccepted: boolean) => {
    if (cookiesAccepted) {
      document.cookie = `${name}=${value}; path=/; ${options.maxAge ? `max-age=${options.maxAge}` : ''}`;
    }
  },

  /**
   * Remove a specific cookie
   */
  removeCookie: (name: string) => {
    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  },
}; 